'use client';
import { type ForwardedRef, type JSX } from 'react';

/* eslint-disable-next-line no-restricted-imports */
import RootFormControl, {
  type FormControlProps as RootFormControlProps,
} from '@mui/material/FormControl';

export type FormControlProps = Omit<RootFormControlProps, 'size'>;

/**
 * An extension of MUI's {@link RootFormControl} component that removes the 'size' prop.  Size is
 * not configurable on the form control itself; the size-specific styling of the enclosed input is
 * instead derived from the internalized {@link Select} and {@link InputLabel} components, which
 * apply their own 'data-attr-size' attribute that the global theme keys off of.
 */
export const FormControl = ({
  ref,
  ...props
}: { readonly ref?: ForwardedRef<HTMLDivElement> } & FormControlProps): JSX.Element => (
  <RootFormControl {...props} ref={ref} />
);
